export type SingleLoadOutcome = 'render' | 'access-denied' | 'error';

export interface SingleLoadContext {
  isSupplier: boolean;
  code: number;
  hasError: boolean;
  requestedId: number;
  /** id из тела ответа; null — тела нет. */
  receivedId: number | null;
}

const ACCESS_DENIED_CODES = [401, 403, 404];

/**
 * Для поставщика запрет и «лист не найден» означают одно: лист не его — уводим на
 * AccessDenied, не показывая ни номер листа, ни пустую карточку. Внутренним ролям
 * показываем уведомление об ошибке, как раньше.
 *
 * Сверка requestedId с receivedId — защита поверх серверного ACL.
 */
export function resolveSingleLoadOutcome(ctx: SingleLoadContext): SingleLoadOutcome {
  if (ctx.hasError) {
    if (ctx.isSupplier && ACCESS_DENIED_CODES.includes(ctx.code)) {
      return 'access-denied';
    }
    return 'error';
  }
  if (ctx.receivedId === null || ctx.receivedId !== ctx.requestedId) {
    return ctx.isSupplier ? 'access-denied' : 'error';
  }
  return 'render';
}
